import React, { useState, useContext } from 'react';
import { Autocomplete, TextField, IconButton, Tooltip } from '@mui/material';
import { SearchSharp, KeyboardArrowDownSharp, KeyboardArrowUpSharp, ClearAllSharp, ClearSharp } from '@material-ui/icons';
import { FilterList as FilterListIcon } from '@mui/icons-material';
import { ThemeContext } from '../ThemeContext/ThemeContext';

const SearchBar = ({ options, onSearchChange, onSortRooms, sortOrder, clearSearch, onAdvancedSearch, placeholder = 'Pesquisar', sx, initialValue = '' }) => {
  const [searchValue, setSearchValue] = useState(initialValue);
  const { theme } = useContext(ThemeContext);

  return (
    <Autocomplete
      sx={{ ...sx }}
      disableClearable
      freeSolo
      inputValue={searchValue}
      options={options}
      filterOptions={(options, state) => options.filter(option =>
        option.toLowerCase().includes(state.inputValue.toLowerCase())
      )}
      onInputChange={(event, newValue) => {
        setSearchValue(newValue);
        onSearchChange(newValue);
      }}
      renderOption={() => <></>}
      PaperComponent={() => <></>}
      renderInput={(params) => (
        <TextField variant='filled' {...params} placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {params.InputProps.endAdornment}
                {onAdvancedSearch && (
                  <IconButton 
                    onClick={() => onAdvancedSearch()} 
                    style={{ color: theme.palette.text.primary }}
                    sx={{ mr: 0.5 }}
                  >
                    <Tooltip title="Busca Avançada">
                      <FilterListIcon />
                    </Tooltip>
                  </IconButton>
                )}
                <IconButton style={{ color: theme.palette.text.primary }}>
                  <Tooltip title="Pesquisar">
                    <SearchSharp />
                  </Tooltip>
                </IconButton>
                {onSortRooms && (
                  <IconButton onClick={() => onSortRooms()} style={{ color: theme.palette.text.primary }}>
                    <Tooltip title={sortOrder === "asc" ? "Ordenar Descendente" : "Ordenar Ascendente"}>
                      {sortOrder === "asc" ? <KeyboardArrowDownSharp /> : <KeyboardArrowUpSharp />}
                    </Tooltip>
                  </IconButton>
                )}
                {clearSearch && (
                  <IconButton onClick={() => { setSearchValue(''); clearSearch(); }} style={{ color: theme.palette.text.primary }}>
                    <Tooltip title="Limpar Busca">
                      <ClearSharp />
                    </Tooltip>
                  </IconButton>
                )}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default SearchBar;
